/* eslint-disable complexity, max-len */
import type { ReactNode } from 'react'
import React, { PureComponent } from 'react'

import Icon from '@vfuk/core-icon'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import DateTextInput, { dateFormatter } from '@vfuk/core-date-text-input'

import { getDataSelector } from '@vfuk/core-base-props'

import type { DateTextInputWrapperProps } from './DateTextInputWrapper.types'

import * as Styled from './styles/DateTextInputWrapper.style'

dayjs.extend(customParseFormat)

export default class DateTextInputWrapper extends PureComponent<DateTextInputWrapperProps> {
  handleOnChange = (date: Date | null | 'error', dateString: string): void => {
    if (date && date !== 'error') {
      // Clears the errors array when the date is valid
      this.props.onInvalidInputEntry([])
    }
    this.props.onDateChange(date, dateString)
  }

  private convertStringToDate(): Date | null {
    if (this.props.value) {
      return dateFormatter(this.props.value, this.props.showMonthYearPicker).toDate()
    }
    return null
  }

  public render(): ReactNode {
    const { iconAppearance } = this.props.calendarPickerTheme!

    return (
      <Styled.DateTextInputWrapper data-selector={getDataSelector(this.props.dataSelectorPrefix)}>
        <DateTextInput
          name={this.props.name}
          id={this.props.id}
          value={this.convertStringToDate()}
          rawValue={this.props.rawValue}
          required={this.props.required}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          includeDates={this.props.includeDates}
          excludeDates={this.props.excludeDates}
          filterDate={this.props.filterDate}
          showMonthYearPicker={this.props.showMonthYearPicker}
          onInvalidInputEntry={this.props.onInvalidInputEntry}
          onBlur={this.props.onBlur}
          onChange={this.handleOnChange}
          onClick={this.props.onClick}
          state={this.props.state}
          errorMessages={this.props.errorMessages}
          autoComplete={this.props.inputAutoComplete}
          describedBy={this.props.describedBy}
          labels={this.props.labels}
          dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix, this.props.name)}
        />
        {(this.props.state === 'disabled' || !this.props.state) && (
          <Styled.IconWrapper>
            <Styled.IconContainer>
              <Icon
                name='calendar'
                appearance={iconAppearance}
                size={1}
                dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix, 'calendar')}
              />
            </Styled.IconContainer>
          </Styled.IconWrapper>
        )}
      </Styled.DateTextInputWrapper>
    )
  }
}
